import { getNlsString } from '../../nls/nlsRuntime'
import type { NlsInterpolationValues } from '../../nls/nlsTypes'
import type { NlsKey } from '../../nls/strings_nls'

export type MeetingViewMode = 'DAY' | 'WEEK' | 'MONTH' | 'YEAR'
export type MeetingSectionMode = 'SCHEDULE' | 'HUDDLE' | 'MEETING'
export type MeetingsNlsT = (key: NlsKey, values?: NlsInterpolationValues) => string

const defaultMeetingsT: MeetingsNlsT = (key, values) => getNlsString(key, values)

export const getMeetingViewLabels = (t: MeetingsNlsT = defaultMeetingsT): Array<{ id: MeetingViewMode; label: string }> => [
  { id: 'DAY', label: t('NLSMeetingsViewDay') },
  { id: 'WEEK', label: t('NLSMeetingsViewWeek') },
  { id: 'MONTH', label: t('NLSMeetingsViewMonth') },
]

export const getMeetingSectionLabels = (t: MeetingsNlsT = defaultMeetingsT): Array<{ id: MeetingSectionMode; label: string }> => [
  { id: 'SCHEDULE', label: t('NLSMeetingsSectionScheduleLabel') },
  { id: 'HUDDLE', label: t('NLSMeetingsSectionHuddleLabel') },
  { id: 'MEETING', label: t('NLSMeetingsSectionMeetingLabel') },
]

export const getMeetingSectionMeta = (section: MeetingSectionMode, t: MeetingsNlsT = defaultMeetingsT) => {
  if (section === 'SCHEDULE') return { label: t('NLSMeetingsSectionScheduleLabel'), tone: t('NLSMeetingsSectionScheduleTone') }
  if (section === 'HUDDLE') return { label: t('NLSMeetingsSectionHuddleLabel'), tone: t('NLSMeetingsSectionHuddleTone') }
  return { label: t('NLSMeetingsSectionMeetingRoomLabel'), tone: t('NLSMeetingsSectionMeetingTone') }
}

export const formatMeetingCount = (count: number, t: MeetingsNlsT = defaultMeetingsT): string =>
  `${count} ${t(count === 1 ? 'NLSMeetingsLabelMeetingOne' : 'NLSMeetingsLabelMeetingMany')}`

export const getMeetingDirtyDialog = (t: MeetingsNlsT = defaultMeetingsT) => ({
  title: t('NLSMeetingsDialogDiscardTitle'),
  message: t('NLSMeetingsDialogDiscardMessage'),
  cancelLabel: t('NLSCommonActionCancel'),
  discardLabel: t('NLSMeetingsActionDiscard'),
})
